import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tillocash_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const api = {
  // auth
  signup: (payload) => http.post("/auth/signup", payload).then((r) => r.data),
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  changePassword: (current_password, new_password) =>
    http.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
  updateProfile: (name) => http.put("/auth/profile", { name }).then((r) => r.data),
  updateLanguage: (language) => http.put("/auth/language", { language }).then((r) => r.data),
  translate: (text, target) => http.post("/translate", { text, target }).then((r) => r.data),
  validateInvite: (token) => http.get(`/invite/${token}`).then((r) => r.data),

  // account / team
  getAccount: () => http.get("/account").then((r) => r.data),
  updateAccount: (business_name) => http.put("/account", { business_name }).then((r) => r.data),
  listAccountUsers: () => http.get("/account/users").then((r) => r.data),
  removeAccountUser: (id) => http.delete(`/account/users/${id}`).then((r) => r.data),
  deleteAccount: (password) => http.delete("/account", { data: { password } }).then((r) => r.data),

  // invitations
  getInvitation: () => http.get("/invitations").then((r) => r.data),
  generateInvitation: () => http.post("/invitations/generate").then((r) => r.data),
  revokeInvitation: () => http.post("/invitations/revoke").then((r) => r.data),

  // employees
  listEmployees: () => http.get("/employees").then((r) => r.data),
  createEmployee: (name) => http.post("/employees", { name }).then((r) => r.data),
  updateEmployee: (id, name) => http.put(`/employees/${id}`, { name }).then((r) => r.data),
  deleteEmployee: (id) => http.delete(`/employees/${id}`).then((r) => r.data),

  // counts
  listCounts: () => http.get("/counts").then((r) => r.data),
  createCount: (payload) => http.post("/counts", payload).then((r) => r.data),
  getCount: (id) => http.get(`/counts/${id}`).then((r) => r.data),

  // settings
  getSettings: () => http.get("/settings").then((r) => r.data),
  updateSettings: (payload) => http.put("/settings", payload).then((r) => r.data),
};
